module.exports = __webpack_public_path__ + "assets/img/sh13.1ccb27bc.jpg";